// @flow

import styled from 'styled-components';
import { theme } from '../theme';

export const Link = styled.a`
  color: ${theme.colors.gray(50)};
  text-decoration: underline;
`;
